import { VersionedFileEntityType } from '@nkr/enums/index';
export interface IUpdateCenterProfileRequest {
    id: number,
    webUrl: string,
    name: string,
    earliestOrganPickupTime: string,
    latestOrganPickupTime: string,
    timezone: string,
    avgCostLDEvalWorkup: number,
    achRoutingNumber: string,
    achAccountNumber: string,
    invoiceDaysToRemit: number,
    streamlinedHospitalBilling: boolean,
    physicianDonorNephrectomyCharges: number,
    provideSwapChecklists: boolean,
    isTaxExempt: boolean,
    taxExemptExpirationDate: string,
    canUtilizeA2toBPatients: boolean,
    w9: File,
    cmsLetter: File,
    salesTaxExemptCert: {
        fileType: VersionedFileEntityType,
        fileVersion: number,
        fileDate: string,
        file: File
    },
    leadCoordinatorId: number,
    organType: number
}
